import { workspaceNoun } from "../public-site/publicSiteUtils";

export function MemberPortalUnavailablePanel({
  appLabel = "This area",
  appDetail = "",
  range = {}
}) {
  const workspace = workspaceNoun(range, "range");

  return (
    <section className="member-portal-unavailable-panel">
      <span className="public-section-kicker">{appLabel}</span>
      <h2>{appLabel} is not available here yet</h2>
      <p>
        {appDetail || `This ${workspace} has not published that member workspace yet. When it is available, it will appear in the member app navigation.`}
      </p>
      <div className="member-portal-focus-row">
        <a href="#member-dashboard">
          <span>Go back</span>
          <strong>Open Today</strong>
          <small>Return to your current member status and next step.</small>
          <em>Member portal</em>
        </a>
        <a href="#member-support">
          <span>Need help?</span>
          <strong>Open Support</strong>
          <small>Contact the {workspace} if you expected this member area to be available.</small>
          <em>Contact path</em>
        </a>
      </div>
    </section>
  );
}

export function MemberPortalAccessGate({
  displayName,
  isAuthenticated,
  loading,
  membershipHref,
  workspaceLabel = "range",
  onRequireAuth,
  onSignOut
}) {
  const signedInBlocked = isAuthenticated && !loading;
  return (
    <section className="member-access-gate" id="member-dashboard">
      <div>
        <span className="public-section-kicker">Member access</span>
        <h2>
          {signedInBlocked
            ? `No member access for ${displayName || `this ${workspaceLabel}`} yet`
            : `Sign in for ${displayName || `this ${workspaceLabel}`} member access`}
        </h2>
        <p>
          {signedInBlocked
            ? `You are signed in, but this account is not connected to a membership, pending signup, or expired member record for this ${workspaceLabel}.`
            : `Use your ArmorySync account after starting a membership request or completing checkout for this ${workspaceLabel}.`}
        </p>
      </div>
      {loading ? (
        <div className="member-access-gate-status">Checking range membership access...</div>
      ) : (
        <>
          <div className="member-access-gate-actions">
            <a className="public-primary-action" href={membershipHref}>
              View membership plans
            </a>
            {!isAuthenticated && (
              <button type="button" className="secondary-button" onClick={onRequireAuth}>
                Sign in or create account
              </button>
            )}
            {isAuthenticated && onSignOut && (
              <button type="button" className="secondary-button" onClick={onSignOut}>
                Sign out
              </button>
            )}
          </div>
        </>
      )}
    </section>
  );
}
